<template>
    <nav class="navbar navbar-expand-lg">
        <div class="container">
            <div class="flex_mobile">
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <router-link to="/" class="logo_mobile">
                    <img src="@/assets/media/logo.png" alt="logo">
                </router-link>
            </div>
            <div class="navbar_content">
                <div class="collapse navbar-collapse" id="navbarNav">
                    <ul class="navbar-nav">
                        <li class="nav-item">
                            <router-link class="nav-link" to="/">{{$t("home")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" to="/works">{{$t("work")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" to="/about">{{$t("about")}}</router-link>
                        </li>
                    </ul>
                    <router-link to="/" class="logo_laptop">
                        <img src="@/assets/media/logo.png" alt="logo">
                    </router-link>
                    <socialMedia />
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
import socialMedia from '../include/social/socialMedia.vue'

export default {
    name: "navbar-layout",
    components: {
        socialMedia
    }
}
</script>

<style>
    
</style>